
export default {
  name: 'BbSrCard',
  props: {
    name: {
      type: String,
      default: '',
    },
    status: String,
    label: String,
    isActive: {
      type: Boolean,
      default: false,
    },
    thumbUrl: String,
    thumbPromise: Promise,
    truncationLength: {
      type: Number,
      default: 100,
    },
    hint: String,
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      url: {},
    };
  },
  computed: {
    unifieredStatus() {
      return this.status?.toLowerCase();
    },
    backgroundImageStyle() {
      const backgroundUrlRegex = new RegExp(/^url\(/);
      const formatedUrl = backgroundUrlRegex.test(this.url) ? this.url : `url(${this.url})`;
      return { backgroundImage: formatedUrl };
    },
    shouldBeTruncated() {
      return this.name.length > this.truncationLength;
    },
    computedName() {
      return this.shouldBeTruncated ? `${this.name.slice(0, this.truncationLength)}...` : this.name;
    },
  },
  created() {
    if (this.thumbUrl) {
      this.url = this.thumbUrl;
    } else if (this.thumbPromise) {
      this.thumbPromise.then((url) => { this.url = url; });
    }
  },
  watch: {
    thumbPromise() {
      this.thumbPromise.then((url) => { this.url = url; });
    },
    thumbUrl() {
      this.url = this.thumbUrl;
    },
  },
};
